<template>
  <div class="row d-flex justify-content-center">
    <div class="col-10 mt-2">
      <el-card shadow="always" class="p-0" style="border-radius: 10px;" :body-style="{ padding: '0px' }">
        <div class="row bg-navy py-2 px-3 mb-5">
          <div class="col-12 text-center">
            <h3 class="mb-0 text-white text-uppercase">Property Identification Code</h3>
          </div>
        </div>
        <div class="mx-5">
          <div class="row my-4">
            <div class="col-12 text-navy font-weight-bold text-center">
              PIC Search
              <input v-model="business.pic" />
              <el-button class="action-btn btn-green-agent" @click="getPCIData" type="primary"
                style="width: 50px;height: 40px;">
                Go
              </el-button>
            </div>
          </div>
          <div v-if="pic_data" class="row">
            <div class="col-4"></div>
            <div class="col-4 producer-data">
              <div class="row">
                <div class="col-6 text-navy font-weight-bold p-1">PIC</div>
                <div class="col-6"></div>
              </div>
              <div class="row">
                <div class="col-6 text-navy font-weight-bold p-1 text-uppercase">Property Name</div>
                <div class="col-6"></div>
              </div>
              <div class="row">
                <div class="col-6 text-navy font-weight-bold p-1 text-uppercase">First Name</div>
                <div class="col-6"></div>
              </div>
              <div class="row">
                <div class="col-6 text-navy font-weight-bold p-1 text-uppercase">Last Status</div>
                <div class="col-6"></div>
              </div>
              <div class="row">
                <div class="col-6 text-navy font-weight-bold p-1 text-uppercase">Business Name</div>
                <div class="col-6"></div>
              </div>
              <div class="row">
                <div class="col-6 text-navy font-weight-bold p-1 text-uppercase">PIC Status</div>
                <div class="col-6"></div>
              </div>
              <div class="row">
                <div class="col-6 text-navy font-weight-bold p-1 text-uppercase">Town</div>
                <div class="col-6"></div>
              </div>
              <div class="row">
                <div class="col-6 text-navy font-weight-bold p-1 text-uppercase">State</div>
                <div class="col-6"></div>
              </div>
              <div class="row">
                <div class="col-6 text-navy font-weight-bold p-1 text-uppercase">Postcode</div>
                <div class="col-6"></div>
              </div>
              <div class="row">
                <div class="col-12 text-right p-1">
                  <el-button class="action-btn btn-green-agent" @click="addPic" type="primary"
                    style="width: 50px;height: 40px;">
                    <i class="fas fa-plus fa-lg"></i>
                  </el-button>
                </div>
              </div>
            </div>
            <div class="col-4 pl-5">
              <div v-for="(item, index) in pics" v-bind:key="index" class="text-navy font-weight-bold">
                <i class="fas fa-times fa-lg text-grey pr-3" @click="removePic(index)"></i> {{ item.pic }} | {{ item.name
                }}
              </div>
            </div>
          </div>
          <div class="row my-4">
            <div class="col-12 text-right">
              <el-button class="action-btn text-uppercase" type="primary" @click="$emit('save-data')">
                Proceed
              </el-button>
              <el-button class="action-btn  text-uppercase btn-green" type="primary" @click="$emit('save-data')">
                Save progress
              </el-button>
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>

export default {
  props: {
  },
  mounted() {

  },
  data() {
    return {
      business: {
        pic: '',
      },
      pic_data: false,
      pics: [],
    };
  },
  methods: {
    getPCIData() {
      this.pic_data = true;
    },
    addPic() {
      let data = { pic: 'NC046573', name: 'Hopewood & Parker &MCkey' };
      this.pics.push(data)
    },
    removePic(index) {
      this.pics.splice(index, 1)
    }
  },
};
</script>
<style scoped>
.producer-data .row:nth-of-type(odd) div {
  background-color: #f4f4f5;
}

.producer-data .row:nth-of-type(even) div {
  background: #FFFFFF;
}
</style>
